<template>
    <section>
        <Header></Header>
        <div class="wrap">
    <div class="main">
        <div class="banner">
            <img src="../../../static/images/ysxy-banner.jpg" alt="">
        </div>
    </div>
    <div class="font-box">
        <h2 class="big-tit">隐私声明</h2>
        <p style="color: #333;">2023年12月11日更新</p>
    </div>
    <div class="font-box">
        <p>
            当用户（以下简称“您”）在网络环境下使用欧朋相关服务时，欧朋（以下简称“我们”）提供了保护隐私安全的一系列良好的功能。通过欧朋的服务，基于尊重用户隐私权（包括保护个人诚信和私人生活，并且确保对个人信息的保护有足够力度）的原则，形成了欧朋保护个人信息的政策即本隐私声明。
        </p>
    </div>
    <div class="font-box">
        <h3>隐私政策</h3>
        <p class="mbt-15">本节为欧朋隐私政策的总则部分，涵盖了关于欧朋隐私权保护的概要信息。<br>
            与欧朋浏览器、欧朋同步服务、欧朋数据压缩服务、欧朋网站相关的隐私政策和相关问题，请参见下面的相应章节：</p>
        <p>
            <a href="#section1">·基于欧朋网络服务的隐私政策</a> <br>
            <a href="#section2">·欧朋浏览器的隐私政策</a>   <br>
            <a href="#section3">·欧朋同步服务的隐私政策</a> <br>
            <!-- <a href="#section4"> ·欧朋数据压缩服务的隐私政策</a> <br>-->
            <a href="#section5">·欧朋网站的隐私政策</a>
        </p>
    </div>
    <div class="font-box">
        <h3>隐私声明的修改</h3>
        <p>我们会不时地更新我们的隐私声明。当我们公布隐私声明的修改更新时，我们会标明更新日期。我们鼓励您定期查阅我们的隐私声明。</p>
    </div>
    <div id="section1" class="font-box">
        <h3 >基于欧朋网络服务的隐私政策</h3>
        <p class="mbt-15">欧朋提供一系列基于互联网的服务，包括但不限于欧朋浏览器、欧朋同步服务、欧朋数据压缩服务。我们保留增加、减少或变更前述服务的权利。欧朋严格保护您在这些服务领域范围内的个人信息。我们在前述服务领域范围内制定了保护措施来保护您的信息免遭窃用、更改或破坏。所有的用户都应谨慎妥善保管、处理自己或他人的个人信息。除非根据法律规定或有权部门的要求披露的，我们保证您的个人信息不被披露。</p>
        <h4>处理</h4>
        <p class="mbt-15">仅在隐私政策中提到的具体目的下，个人信息才会被收集、存储、使用。欧朋收集用户提交的信息、IP地址、使用模式和用户访问欧朋网站或使用欧朋服务的时间点。</p>
        <h4>目的</h4>
        <p>处理个人信息仅限于运行、调试、维护和/或优化服务和/或维护用户关系的目的。此外，在某些情况下，我们可能使用个人信息来向用户发送一些关于下载更新、升级、改进、调查的信息或广告。</p>
        <p class="mbt-15">对网络或服务使用的分析（目的为调试、维护和优化服务）不会基于披露个人用户的使用模式，而是基于聚合的数据和匿名的个人身份。除非根据法律规定或有权部门的要求披露的，欧朋不会共享或披露前述细节。</p>
        <h4>获取</h4>
        <p class="mbt-15">欧朋对获得用户信息的权限有严格限制。仅有极少数欧朋员工能够获得。</p>
        <h4>修正</h4>
        <p class="mbt-15">使用欧朋产品和服务的用户可以在任何时间更改他们曾经提交的个人信息。</p>
        <h4>检验</h4>
        <p class="mbt-15">程序将被定期检验，以保证隐私政策得到遵守。任何违反本政策的行为都将被毫不延迟的纠正。</p>
        <h4>安全</h4>
        <p class="mbt-15">欧朋在欧朋产品和服务的范围内严格保护个人信息安全。我们有防止用户信息盗用、更改或破坏的保护措施。除非根据法律规定或有权部门的要求披露的，欧朋保证任何用户信息都不被披露。</p>
        <h4>未成年人指引</h4>
        <p class="mbt-15">欧朋在互联网上提供了互动环境来使用户通过创建和参与论坛讨论来展示自己、分享他们的想法和兴趣。欧朋论坛无法禁止未成年人在没有父母同意的情况下进入或使用欧朋相关服务或者留下个人信息。并且，欧朋无法禁止未成年人在欧朋论坛发布个人信息。因此，我们主张未成年人应在父母的陪伴下进行注册及其他活动，而且我们主张未成年人的父母在允许他们的孩子使用欧朋服务前应阅读本隐私声明。</p>
        <h4>联系信息</h4>
        <p>如果您对本隐私声明有任何的疑问，或者对欧朋或欧朋产品隐私权问题有疑问的，您可以以电子邮件的方式将您的疑问发送到下面的邮箱地址：<br>
            share@oupeng.com</p>
    </div>
    <div id="section2" class="font-box">
        <h3>欧朋浏览器的隐私政策</h3>
        <p class="mbt-15">欧朋公司在发展过程中很重视保护用户的隐私安全不受危害。个人信息不会被非法使用。</p>
        <p class="mbt-15">欧朋浏览器在用户访问网址和用户使用内置搜索相关功能时接收记录了cookies。您可以通过菜单-设置-隐私（高级）中选择不被欧朋浏览器获取cookies，但这将影响您对欧朋浏览器某些功能的使用。</p>
        <p class="mbt-15">欧朋保留在根据法律规定或在司法进程中，被司法机关命令或有权机关要求披露，或为维护欧朋的权益欧朋认为有必要披露时而披露相关个人信息的权利。</p>
        <h4>欧朋浏览器的内置网络搜索</h4>
        <p class="mbt-15">欧朋浏览器有内置的网络搜索功能，给用户提供了直接在浏览器界面使用外部搜索引擎的选择。这项网络搜索服务是依托于第三方的服务，欧朋浏览器将用户的搜索请求直接发送到第三方网站来处理实际搜索查询，但用户的个人信息不会被发送。</p>
        <p class="mbt-15">某些第三方网站可能从欧朋浏览器统计数据流量，例如点击数量或用户使用的搜索词条。欧朋保证个人的可识别信息将不会被第三方网站获得。</p>
        <p>请注意：欧朋不能控制第三方及其网站的隐私政策和保护隐私安全的措施。请登陆第三方的网站和/或查阅第三方的商业平台来获取更多的信息。欧朋浏览器的用户有责任在通过第三方及其网站提供的信息收集表格或其他途径提交、披露或分享个人信息时保持谨慎。</p>
    </div>
    <div id="section3" class="font-box">
        <h3>欧朋同步服务的隐私政策</h3>
        <p>欧朋同步服务允许注册用户在他们安装了欧朋浏览器的不同移动终端之间同步书签等相关数据。除非根据法律规定或有权部门要求披露的，或者是您选择授权第三方应用或服务来获得欧朋同步服务API接口的情况下，欧朋不会披露、分享或分发任何个人的同步信息给任何第三方。欧朋严格限制可以获得用户同步信息的内部员工，仅那些需要运营欧朋同步服务的员工能够获得相关的用户同步信息。欧朋可能会保留IP地址、用户ID、匿名流量数据，因为它们可能在调试、优化以及持续改进欧朋同步服务时有用。</p>
    </div>

    <!-- <div id="section4" class="font-box">
        <h3>欧朋数据压缩服务的隐私政策</h3>
        <p>当欧朋数据压缩服务被启用时，网络流量将会被压缩，因而加快了下载速度和减小了数据体积。这项服务是将普通网页内容通过欧朋的转码服务器实现压缩。欧朋搜集IP地址、使用模式、使用服务的时间，目的是用于调试、维护、优化服务或维持用户关系。对服务模式分析是以聚合数据及匿名个人身份的形式实施的。</p>
    </div> -->
    <div id="section5" class="font-box">
        <h3>欧朋网站的隐私政策</h3>
        <p class="mbt-15">以下陈述披露了在oupeng.com和其他欧朋域名收集和传播个人信息的情况。</p>
        <h4 class="mbt-15">数据的收集</h4>
        <p class="mbt-15">IP地址  <br>
            欧朋会不时地收集访问者的IP地址来帮助诊断服务问题和管理网站。我们承诺，我们收集的IP地址不会被用于其他非法用途。<br>
            从表格中收集的信息</p>
        <p class="mbt-15">oupeng.com和其他欧朋域名可能会使用表格供访问者索取欧朋信息、产品或服务。访问者使用表格时提供的联系信息（如电子邮箱地址、手机号码）可能会被我们收集。从这些表格中收集的联系信息是用于向用户发送欧朋相关服务或在必要的时候用于联系用户。</p>
        <h4>Cookies</h4>
        <p class="mbt-15">欧朋网站会使用cookies来提升用户体验，如访问会话管理、用户偏好设置等。欧朋不会从cookies中获得任何的用户个人信息。
        </p>
        <h4>活动</h4>
        <p class="mbt-15">我们会举办一些互动活动。在这些互动活动中，访问者会被要求提供一些联系信息（如电子邮箱地址、联系电话）。访问者的联系信息被用于在必要时联系访问者，且在本目的实现后会被删除。我们不会将此信息售卖给其他人。</p>
        <h4>公共论坛</h4>
        <p class="mbt-15">欧朋网站为访问者提供了论坛服务。请您切记，您在欧朋论坛中发布的信息将成为公共信息，您在决定披露您的个人信息时应当谨慎考虑。</p>
        <h4>其他网站的链接</h4>
        <p class="mbt-15">欧朋网站包含了其他网站的链接。欧朋不对其他网站的内容及隐私政策负责。
        </p>
        <h4 class="mbt-15">运营者基本情况</h4>
        <p>欧朋浏览器运营公司主体：北界无限（北京）软件有限公司</p>
        <p>联系邮箱：share@oupeng.com</p>
    </div>
</div>
        <Footer></Footer>
    </section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'yssm',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
	computed: {}
}
</script>

<style scoped>
.banner {
	width: 100%;
	height: 1.1rem;
    background-size: cover;
}
img {
    width: 100%;
    height: 100%;
}
.big-tit {
	color: #000;
	font-size: 30px;
	line-height: 35px
}

.font-box {
	width: 90%;
	margin: 0 auto;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
	color: #333;
	font-size: 12px;
	line-height: 18px;
	text-align: justify
}

.font-box a {
	color: #2f82ab;
	text-decoration: underline
}

h3 {
	font-size: 18px;
	margin-bottom: 15px
}

h4 {
	font-size: 15px
}

.mbt-15 {
	margin-bottom: 15px
}
</style>


// WEBPACK FOOTER //
// src/components/views/Yssm.vue